import AnnuleIcon from "../../../assets/icons/annuleIcon.svg";
import EchuIcon from "../../../assets/icons/EchuIcon.svg";
import EncoursIcon from "../../../assets/icons/EncoursIcon.svg";
import PreIcon from "../../../assets/icons/PreIcon.svg";
import RealiserIcon from "../../../assets/icons/RealiserIcon.svg";
import ShieldCheck from "../../../assets/icons/shieldCheck.svg";
export const statusStyles = {
  Termine: {
    backgroundColor: "#E9FFEF",
    color: "#208B3A",
    icon: ShieldCheck,
  },
  EnCours: {
    backgroundColor: "#DDDFFF",
    color: "#532B88",
    icon: EncoursIcon,
  },
  Pret: {
    backgroundColor: "#DFCDFF ",
    color: "#532B88",
    icon: PreIcon,
  },
  ARealiser: {
    backgroundColor: "#F6F0FF",
    color: "#532B88",
    icon: RealiserIcon,
  },
  Annule: {
    backgroundColor: "#FFE7E7",
    color: "#E52F2F",
    icon: AnnuleIcon,
  },
  Echu: {
    backgroundColor: "#FFF2E0",
    color: "#FEAF4E",
    icon: EchuIcon,
  },
};
